export default {
  methods: {
    setLaureat (item, index, current) {
      this.col(item, index)
      this.top(item)
      this.width(item, index, current)
      this.left(item, index, current)
      this.right(item, index, current)
      if (!item.image.src) this.padding(item)
    },

    padding (item) {
      item.padding = Math.floor(Math.random() * (80 - 120 + 1)) + 120
    },

    col (item, index) {
      item.col = index % 3
    },

    top (item) {
      item.top = Math.floor(Math.random() * (4 - 1 + 1)) + 1
    },

    width (item, index, current) {
      let colWidth

      // First or second
      if (item.col === 0 || item.col === 1) {
        colWidth = Math.floor(Math.random() * (36 - 30 + 1)) + 30
      }

      // Last
      if (item.col === 2) {
        colWidth = 100 - current[index - 1].colWidth - current[index - 2].colWidth
      }

      item.colWidth = colWidth
    },

    left (item, index, current) {
      // First
      let leftWidth
      if (item.col === 0) {
        leftWidth = Math.floor(Math.random() * (3 - 1 + 1)) + 1
      // Second
      } else if (item.col === 1) {
        let prevL = current[index - 1].leftWidth
        let ops = [1, 2, 3]
        ops.splice(prevL - 1, 1)
        leftWidth = ops[Math.floor(Math.random() * ops.length)]
      // Third
      } else {
        let prevL = current[index - 2].leftWidth
        let prevLL = current[index - 1].leftWidth

        let ops = [1, 2, 3]

        ops.splice(ops.findIndex(e => e === prevL), 1)
        ops.splice(ops.findIndex(e => e === prevLL), 1)

        leftWidth = ops[0]
      }

      item.leftWidth = leftWidth
    },

    right (item, index, current) {
      // First
      let rightWidth
      if (item.leftWidth === 1) rightWidth = 3
      if (item.leftWidth === 2) rightWidth = 1
      if (item.leftWidth === 3) rightWidth = 2

      item.rightWidth = rightWidth
    }
  }
}
